import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=93ee8604&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=ts&"
export * from "./faq.vue?vue&type=script&lang=ts&"
import style0 from "./faq.scss?vue&type=style&index=0&id=93ee8604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ee8604",
  null
  
)

component.options.__file = "faq.vue"
export default component.exports